import script from "./LoginL.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginL.vue?vue&type=script&setup=true&lang=js"

import "./LoginL.vue?vue&type=style&index=0&id=ce4acac4&lang=less"

const __exports__ = script;

export default __exports__